import { Helmet, HelmetProvider } from 'react-helmet-async';

const CspHeader = () => {
  let csp = '';
  csp += `default-src 'none';`;
  csp += `script-src 'self' ${process.env.NODE_ENV === 'development' ? "'unsafe-eval'" : ''};`;
  csp += `script-src-elem 'self';`;
  csp += `connect-src 'self' ${process.env.REACT_APP_APPSYNC_END_POINT}
  ${process.env.REACT_APP_COGNITO_IDP_END_POINT}
  ${process.env.REACT_APP_COGNITO_IDENTITY_END_POINT}
  ${process.env.REACT_APP_API_GW_END_POINT}/${process.env.NODE_ENV}/get-report-template-files
  ${process.env.REACT_APP_API_GW_END_POINT}/${process.env.NODE_ENV}/report-quotation
  https://geolocation-db.com/json/
  ws:;`;
  csp += `img-src 'self' data:;`;
  csp += `style-src 'self' 'unsafe-inline';`;
  csp += `prefetch-src 'self';`;
  csp += `manifest-src 'self';`;

  return (
    <HelmetProvider>
      <Helmet>
        <meta httpEquiv="Content-Security-Policy" content={csp} />
      </Helmet>
    </HelmetProvider>
  );
};

export default CspHeader;
